import { EntityType } from '@frontend/common';
import { Spinner } from '@frontend/components/common';
import { Form } from '@frontend/components/forms';
import { DockerImageClient } from '@frontend/version/api';
import { DockerImage, UpdateDockerImage } from '@frontend/version/types';

import { DOCKER_IMAGE_UPDATE_FORM_ID, useDockerImageUpdate } from './docker-image-update.controller';

export const DockerImageUpdate = () => {
    const viewProps = useDockerImageUpdate();

    if (!viewProps.dockerImage) {
        return <Spinner />;
    }
    return (
        <Form<DockerImage, UpdateDockerImage>
            useStaticId
            id={DOCKER_IMAGE_UPDATE_FORM_ID}
            dispatch={viewProps.dispatch}
            type={EntityType.DOCKER_IMAGE}
            value={viewProps.dockerImage}
            onCancel={viewProps.onCancel}
            onSubmit={(v) => DockerImageClient.patchDockerImage(viewProps.dockerImage!.id, v)}
            onSubmitSuccess={viewProps.onSubmitSuccess}
            show={['release_notes']}
            expectedType={new Map([['release_notes', 'textarea']])}
        />
    );
};
